/** Icons generated by create-react-icons. Don't edit this file directly. **/
import React from "react";
import PropTypes from "prop-types";

export function Delete(props) {
  const { size, color, ...other } = props;
  return (
    <svg viewBox="0 0 24 24" fill="none" height={size} width={size} {...other}>
      <path
        d="M5 8H19M15.6208 20H8.37575C7.45962 20 6.69837 19.3074 6.63012 18.4117L5.84525 8H18.125L17.3664 18.4074C17.3007 19.3049 16.5386 20 15.6208 20Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 7.42857L15.1896 5.11257C14.9552 4.44314 14.3584 4 13.6912 4H10.3088C9.6416 4 9.0448 4.44314 8.8104 5.11257L8 7.42857H16Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

Delete.defaultProps = {
  color: "currentColor",
  size: 24,
};

Delete.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
